<template>
  <v-app class="hc-compact-page room-calendar-view room-calendar-page">
    <PageHeader
      :title="`Kalender Penggunaan Ruangan ${clinic_name}`"
      subtitle="Visualisasi penggunaan dan ketersediaan ruangan poliklinik"
      icon="far fa-building"
    >
      <template #actions>
        <div class="room-calendar-page-actions">
          <b-button variant="outline-primary" @click="$router.push('/appointment/list/0')">
            <i class="fas fa-list"></i><span>Lihat Daftar</span>
          </b-button>
          <b-button variant="primary" @click="$router.push('/appointment/add')">
            <i class="fas fa-plus"></i><span>Tambah Perjanjian</span>
          </b-button>
        </div>
      </template>
    </PageHeader>

    <Card
      card-class="appointment-calendar-shell"
      head-size="sm"
    >
      <template v-slot:body>
        <CalendarMode />
      </template>
    </Card>
  </v-app>
</template>

<script>

import Card from '@/view/content/Card.vue'
import CalendarMode from '@/component/appointments/RoomUsageCalendarMode.vue'
import PageHeader from "@/component/general/PageHeader.vue"

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    CalendarMode,
    PageHeader
  },

  data() {
    return {
      clinic_name: window.configuration == null ? "Medhop" : window.configuration.clinic_name
    }
  },

  mounted() {    
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Penggunaan Ruangan", route: "" },
      { title: "Kalender" },
    ])
  },

}
</script>

<style lang="scss">
.hc-schedule-header-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: #ffffff;
  border: 1px solid #e7edf4;
  border-radius: 16px;
  box-shadow: 0 10px 28px rgba(20, 50, 99, 0.05);
}

.hc-schedule-header-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  margin-right: 16px !important;
  border-radius: 12px;
  background: rgba(30, 149, 143, 0.08);
  color: #1e958f;
  font-size: 18px;
}

.hc-schedule-header-title {
  margin: 0 0 2px;
  font-size: 16px;
  font-weight: 600;
  color: #1a2433;
}

.hc-schedule-header-sub {
  font-size: 12px;
  color: #64748b;
}

.room-calendar-view .room-calendar-shell.card {
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  transform: none !important;
}

.room-calendar-view .room-calendar-shell > .card-header {
  min-height: 52px;
  padding: 0 2px 12px;
  border: 0;
  background: transparent;
}

.room-calendar-view .room-calendar-shell > .card-header .card-label {
  margin: 0;
  color: #1a2433;
  font-size: 20px;
  font-weight: 700;
}

.room-calendar-view .room-calendar-shell > .card-body {
  padding: 0 !important;
}

.room-calendar-page-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.room-calendar-page-actions .btn {
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0.55rem 1rem;
  border-radius: 10px;
  font-size: 0.8rem;
  font-weight: 700;
}

.room-calendar-page-actions i {
  margin: 0 !important;
}

@media (max-width: 767px) {
  .room-calendar-page-actions {
    width: 100%;
    flex-direction: column;
  }

  .room-calendar-page-actions .btn {
    width: 100%;
    justify-content: center;
  }

  .room-calendar-view .room-calendar-shell > .card-header .card-label {
    font-size: 18px;
  }
}
</style>
